import CustomStringParam from '../../../table/helpers/custom-string-param';
import { SchemaFilterType } from '../../../table/types';

export const integrationLogsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'type',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'url',
    label: 'URL / Event Type',
    sortable: false,
  },
  {
    name: 'requestTime',
    label: 'Request time',
    sortable: false,
  },
  {
    name: 'responseTime',
    label: 'Response time',
    sortable: false,
  },
  {
    name: 'statusCode',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'responseBody',
    label: 'Body',
    sortable: false,
  },
];

export const integrationLogsColumnsLabels = {};

export const integrationLogsSchema = {
  pspPartnerIds: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};
